'use strict'

// よく使用するElements
export default {
  HTML: document.getElementsByTagName('html')[0],
  BODY: document.getElementsByTagName('body')[0],
  HEADER: document.getElementsByClassName('l-nav')[0],
  MAIN: document.getElementsByTagName('main')[0],
  FOOTER: document.getElementsByTagName('footer')[0],
  COPYRIGHT: document.querySelector('.l-copyright'),
  NAV: document.querySelectorAll('.l-nav__link'),
  HMB: document.querySelector('#hmb'),
  HMBHEAD: document.querySelector('#hmbHead'),
  HMBTIT: document.querySelector('#hmbTitle'),
  HMBBG: document.querySelector('#hmb__bg'),
  HMBBODY: document.querySelector('#hmbBody'),
  STICKY: document.querySelectorAll('.sticky'),
  ANIMATIONS: document.querySelectorAll('.js-sc-animation')
}
